import {
    Component,
    AfterViewInit,
    ViewChild,
    ElementRef,
    Input,
    Renderer2,
    OnDestroy
} from '@angular/core';
import { createPopper } from '@popperjs/core';

import { HeaderDropdownOption } from '@revspringinc/shared';
import { BaseComponent } from '../../../base-component';
import { SidenavService } from '../../sidenav/sidenav.service';
import { HeaderService } from '../header.service';

@Component({
    selector: 'pa-header-dropdown',
    templateUrl: './header-dropdown.component.html',
    styleUrls: ['../../../../../../scss/styles.scss'],
    standalone: false
})
export class HeaderDropdownComponent extends BaseComponent implements AfterViewInit, OnDestroy {
    get isVisible(): boolean {
        return this.sideNavService.getSidenavState().state?.isVisible ?? false;
    }

    get isOverlay(): boolean {
        return this.sideNavService.getSidenavState().state?.isOverlay ?? false;
    }

    public dropdownPopoverShow = false;

    @Input() public dropdownOptions: HeaderDropdownOption[] | undefined;

    @ViewChild("btnDropdownRef", { static: false }) btnDropdownRef: ElementRef | undefined;
    @ViewChild("popoverDropdownRef", { static: false }) popoverDropdownRef: ElementRef | undefined;

    private globalClickUnlistener: (() => void) | undefined;

    constructor(
        public readonly headerService: HeaderService,
        public readonly sideNavService: SidenavService,
        private renderer: Renderer2
    ) {
        super();
    }

    public ngAfterViewInit() {
        if (this.btnDropdownRef && this.popoverDropdownRef) {
            createPopper(
                this.btnDropdownRef.nativeElement,
                this.popoverDropdownRef.nativeElement,
                {
                    placement: 'bottom-end',
                }
            );
        }

        this.globalClickUnlistener = this.renderer.listen('document', 'click', (event: Event) => {
            const clickedInside =
                this.btnDropdownRef?.nativeElement.contains(event.target) ||
                this.popoverDropdownRef?.nativeElement.contains(event.target);

            if (!clickedInside && this.isOverlay === true && this.isVisible === true && window.innerWidth < 1024) {
                this.toggleDropdown();
            }
        });
    }

    public ngOnDestroy() {
        if (this.globalClickUnlistener) {
            this.globalClickUnlistener();
        }
    }

    public toggleDropdown = () => {
        if (window.innerWidth < 1024) {
            this.sideNavService.toggle();
        } else {
            this.dropdownPopoverShow = !this.dropdownPopoverShow;
        }
    }
}
